export const defaultPlanPeriodDays = 14;
/** Must stay in sync with Office.DefaultBookingTimeZone on the backend. */
export const defaultBookingTimeZone = 'Europe/Amsterdam';
export const defaultMaxCapacity = 100;
export const minimalPlanPeriodDays = 5;
export const maximumPlanPeriodDays = 365;
/** Must stay in sync with Office.MaximumGroupPlanPeriodDays on the backend. */
export const maximumGroupPlanPeriodDays = 365;
export const maximumCapacity = 5000;
export const maximumCharacters = 165;
